import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
  partyListItem: {
    padding: '12px 15px',
    minHeight: 46,
    margin: 0,
    maxHeight: 46,
    width: '100%'
  },
  driverListItemFlex:{
    display:'flex',
    alignItems:'center'
  },
  driverListNameFlex:{
    display:'flex',
    alignItems:'center',
    width:'auto',
    maxWidth:200,
    overflow:"hidden",
    whiteSpace:"nowrap", 
    textOverflow: "ellipsis",
  },
  driverListItem: {
    padding: '12px 15px',
    minHeight: 46,
    margin: 0,
    maxHeight: 46,
    width: '100%',
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between'
  },
  partyListItemFlex:{
    display:'flex',
    alignItems:'center'
  },
  partyListNameFlex:{
    display:'flex',
    alignItems:'center',
    width:'auto',
    maxWidth:200,
    overflow:"hidden",
    whiteSpace:"nowrap", 
    textOverflow: "ellipsis",
  },
  partyListItemV1: {
    padding: '12px 15px',
    minHeight: 46,
    margin: 0,
    maxHeight: 46,
    width: '100%',
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between'
  },
  eventIcon: {
    color: 'grey'
  },
  vehicleListItemFlex:{
      display:'flex',
      alignItems:'center',
      flexDirection:'row'
  },
  vehicleListItem: {
    padding: '12px 15px',
    minHeight: 46,
    margin: 0,
    maxHeight: 46,
    width: '100%',
    display: 'flex',
    alignItems:'center',
    justifyContent:'space-between'
  },
  partyAddListItem: {
    padding: '12px 15px',
    margin: 0,
    backgroundColor: '#e3e8fd',
    color: '#0033cc',
    // fontWeight: 300,
    minHeight: 46,
    width: '100%',
    maxHeight: 46
  },
  listBoxAutoCompelete: {
    margin: 0,
    padding: 0
  },
  listBoxOption: {
    padding: 0,
    minHeight: 46,
    maxHeight: 46,
    borderBottom: '1px solid #eaedf3',
    "&:first-child": {
    },
    "&:last-child": {
    }
  },
  addPersonIcon: {
    color: '#0033cc',
    marginRight: 10
  },
  cherveRightIcon: {
    marginLeft: 10,
    float: 'right',
    color: '#0033cc'
  },
  titleBullet: {
    borderRadius: "50%",
    backgroundColor: "lightgrey",
    fontSize: 8,
    color: "lightgrey",
    margin: "0px 6px",
    //marginTop: -2
  },
  listBullet: {
    borderRadius: "50%",
    backgroundColor: "lightgrey",
    fontSize: 6,
    color: "lightgrey",
    margin: "0px 6px",
    marginTop: -2
  },
  avilableBullet: {
    borderRadius: "50%",
    backgroundColor: "#2d9d78",
    fontSize: 8,
    color: "#2d9d78",
    margin: "0px 6px",
    //marginTop: -2
  },
  onTripBullet: {
    borderRadius: "50%",
    backgroundColor: "#0033cc",
    fontSize: 8,
    color: "#0033cc",
    margin: "0px 6px",
    //marginTop: -2
  },
  listRight: {
    float: 'right'
  },
  vehicleNumberSuffix: {
    marginLeft: 3,
    color: "#0033cc",
    marginRight: 3,
    fontWeight: 300
  },
  truckIcon: {
    fontSize: 30, marginTop: -3
  },
  own: {
    padding: "2px 10.5px",
    borderRadius: 3,
    margin: '0px 8px',
    fontSize: 11,
    color: "#fff",
    backgroundColor: '#0033cc',
    letterSpacing: '0.03em'
  },
  hired: {
    padding: "2px 10.5px",
    borderRadius: 3,
    margin: '0px 8px',
    fontSize: 11,
    color: "#fff",
    backgroundColor: '#e86825'
  },
  vehicleStatus: {
    fontSize: 12,
    width:'100%',
    textTransform: 'capitalize',
    alignItems:'center',
    display:'flex',
    justifyContent:'space-between'
  },
  inputsTitle: {
    padding: '0 0',
    marginBottom: 8,
    fontWeight: 700
  },
  inlineInput: {
    display: 'flex',
  },
  ptV1: {
    paddingTop: '0px !important'
  },
  billingTypeRadio: {
    maxWidth: '100% !important',
    marginTop: 16,
    '& .MuiFormControl-fullWidth': {
      //maxWidth:'100% !important'
    },
    '& .MuiFormControlLabel-root': {
      //marginRight:0
    },
    '& .MuiRadio-root': {
      //display:'none'
    },
    '& .MuiFormLabel-root': {
      fontSize: 12,
      letterSpacing: '0.05em',
      marginBottom: 12,
    }
  },
  textV1: {
    width: "48%",
    marginTop: 8,
    "& .MuiInputBase-input": {
      paddingTop: '8.5px',
      paddingBottom: '8.5px'
    }
  },
  textV2: {
    marginTop: 8,
    "& .MuiInputBase-input": {
      paddingTop: '8.5px',
      paddingBottom: '8.5px'
    }
  },
  textV3: {
    marginTop: 8,
    width: '48%',
    "& .MuiInputBase-input": {
      paddingTop: '8.5px',
      paddingBottom: '8.5px'
    }
  },
  titleV1: {
    fontSize: 12,
    color: '#6b778c',
    // marginTop: 12
  },
  titleV4: {
    fontSize: 12,
    color: '#6b778c',
    marginTop: 28
  },
  titleV2: {
    fontSize: 12,
    color: '#6b778c',
    marginTop: 4
  },
  titleV3: {
    fontSize: 12,
    color: '#6b778c',
  },
  divTrip: {
    fontSize: 16,
    fontWeight: 300
  },
  divTripV1: {
    fontSize: 16,
    fontWeight: 300,
    marginTop: 12
  },
  divTripV2: {
    fontSize: 16,
    fontWeight: 300,
    marginTop: 6
  },
  widthV1: {
    width: '48%'
  },
  divV1: {
    width: '49%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  divV2: {
    width: '48%',
    marginTop: 16
  },
  widthV2: {
    width: '49%'
  },
  mtV1: {
    marginTop: 8,
    '& .Mui-disabled':{
      backgroundColor:'#f2f2f2',
    },
    '& .MuiInputBase-root':{
      //border:'solid 1px #b1b8c3'
    }
  },
  textFieldV1: {
    marginTop: 8,
    '& .MuiOutlinedInput-input': {
      textTransform: 'uppercase'
    }
  },
  mtV2: {
    marginTop: 16
  },
  divRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  divRowV1: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  divRowV2: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  divRowV4: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '99%'
  },
  billingTypeLabel: {
    //height: 36,
    //padding: '6px 12px',
    borderRadius: 8,
    marginRight: 6,
    marginLeft: 0,
    backgroundColor: '#e4e4e4',
    '& .MuiButtonBase-root': {
      display: 'none'
    },
    '& .MuiTypography-root': {
      fontSize: 14,
      padding: '8px 12px',
      borderRadius: 8,
      backgroundColor: '#e4e4e4',
      color: '#6b778c',
      fontWeight: 300,
    },
    '& span.Mui-checked+span': {
      color: '#0033cc',
      fontWeight: 300,
      backgroundColor: '#d1ddff',
      border: '1px solid #0033cc',
      paddingTop: 7,
      paddingBottom: 7,
      paddingLeft: 11,
      paddingRight: 11,
      fontSize: 14,
    }
  },
  supplierBillingTypeLabel: {
    //height: 36,
    //padding: '6px 12px',
    borderRadius: 8,
    marginRight: 6,
    marginLeft: 0,
    backgroundColor: '#e4e4e4',
    '& .MuiButtonBase-root': {
      display: 'none'
    },
    '& .MuiTypography-root': {
      fontSize: 14,
      padding: '12px 14px',
      borderRadius: 8,
      backgroundColor: '#e4e4e4',
      color: '#6b778c',
      padding: '8px 12px',
      fontWeight: 300,
    },
    '& span.Mui-checked+span': {
      color: '#e86825',
      fontWeight: 300,
      backgroundColor: '#f9e6b5',
      // letterSpacing: '1px',
      border: '1px solid #e86825',
      paddingTop: 7,
      paddingBottom: 7,
      paddingLeft: 11,
      paddingRight: 11,
      fontSize: 14,
    }
  },
  textNote: {
    alignItems: 'start !important',
    marginTop: 8,
    "& .MuiInputBase-root": {
      alignItems: 'start !important'
    }
  },
  dateV1: {
    marginTop: 8,
    width: '48%',
  },
  dateV2: {
    marginTop: 8,
    width: '49%',
  },
  divRowV3: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  addMoreDetailsButton: {
    textTransform: 'capitalize',
    color: '#0033cc',
    borderColor: '#0033cc',
    backgroundColor: '#efeff2',
    fontSize: 13,
    marginTop: 4,
    borderRadius: 4
  },
  inputAdornmentV1: {
    height: '0 !important',
    alignItems: 'baseline'
  },
  unitCard: {
    padding: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  unitDesc: {
    color: '#7c818d',
    fontSize: 14
  },
  unitAmount: {
    fontWeight: 600,
    fontSize: 14
  },
  freightCard: {
    backgroundColor: '#d1ddff'
  },
  truckHireCard: {
    backgroundColor: '#f9e6b5'
  },
  paymentForm: {
    marginTop: 8
  },
  checkboxInput: {
    width: '100%'
  },
  checkboxTripLabel: {
    height: '100%',
    minHeight: 64,
    maxHeight: 100,
    backgroundColor: '#f1f1f3',
    borderRadius: 8,
    marginLeft: 0,
    marginRight: 0,
    width: '100%',
    padding: 12,
    '& .MuiFormControlLabel-label': {
      width: '100%'
    }
  },
  routePath: {
    fontSize: 14,
    fontWeight: 600
  },
  routePathIcon: {
    color: 'darkgray'
  },
  BULLET: {
    color: "#e4e4e4",
    fontSize: 12,
    margin: '-1px 2px 0 2px'
  },
  tripDetailsDate: {
    color: '#6d717b',
    fontSize: 12
  },
  tripDetailsVehicle: {
    color: 'inherit',
    fontSize: 12
  },
  displayCheckBox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '0.5em',
    //justifyContent:'center'
  },
  tripDetailsBalance: {
    float: 'right',
    color: '#0033cc',
    fontSize: 12,
    fontWeight: 300
  },
  cardInput: {
    backgroundColor: 'white',
    marginLeft: '0.5em',
    width: 130,
    '& .MuiOutlinedInput-input': {
      paddingTop: 6,
      paddingBottom: 6
    }
  },
  tripDetailsPaid: {
    fontSize: 14,
    fontWeight: 300
  },
  tripDetailsBalancePaid: {
    fontSize: 14,
    fontWeight: 300,
    color: '#0033cc'
  },
  tripFullPayment: {
    backgroundColor: '#d7e1fe',
    padding: '2px 4px',
    borderRadius: 4,
    textTransform: 'uppercase',
    color: '#2c5de5',
    fontWeight: 300,
    fontSize: 8
  },
  tripPartPayment: {
    backgroundColor: '#fad1b7',
    padding: '2px 4px',
    borderRadius: 4,
    textTransform: 'uppercase',
    color: '#f27f36',
    fontWeight: 300,
    fontSize: 8
  },
  switchLabel: {
    marginLeft: 0
  },
  switchControl: {
    marginTop: 16,
    marginBottom: 8
  },
  allocation: {
    width: '100%',
    padding: 24,
    paddingBottom: 0
  },
  fullyAllocated: {
    backgroundColor: '#d6f3e2',
    padding: '12px 8px',
    borderRadius: 8
  },
  fullyAllocatedIcon: {
    color: '#00875a',
    marginRight: 8
  },
  partiallyAllocated: {
    backgroundColor: '#fad1b7',
    padding: '12px 8px',
    borderRadius: 8
  },
  partiallyAllocatedIcon: {
    color: '#f27f36',
    marginRight: 8
  },
  ownershipType: {
    marginLeft: 'auto',
    width: 70,
    textAlign: 'right',
    fontWeight: 'bold'
  },
  vehicleStatusDiv: {
    width: 75,
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center'
  },
  divVehicleListing: {
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
  },
  autoCompleteV1: {
    paddingTop: '4px !important',
    paddingBottom: '4px !important'
  }
}));
export default useStyles;